module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.orderDataShow.attributes.is_from_grabr_flag || _vm.orderDataShow.attributes.is_from_linio_flag || _vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "card-body"
  }, [(_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('div', {
    staticClass: "msj-inversion"
  }, [_c('span', [_vm._v("Inviertes " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.real_price + _vm.orderDataShow.attributes.real_tax + _vm.orderDataShow.attributes.real_shipping + _vm.orderDataShow.attributes.cut)) + "\n    y ganas " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.evaluation_info.attributes.grabr_total + _vm.orderDataShow.attributes.grabrOrder.attributes.debit - (_vm.orderDataShow.attributes.evaluation_info.attributes.real_total_cost))) + ".\n    Un  " + _vm._s(_vm._f("currency")((((_vm.orderDataShow.attributes.evaluation_info.attributes.grabr_total + _vm.orderDataShow.attributes.grabrOrder.attributes.debit - (_vm.orderDataShow.attributes.evaluation_info.attributes.real_total_cost)) * 100) / (_vm.orderDataShow.attributes.real_price + _vm.orderDataShow.attributes.real_tax + _vm.orderDataShow.attributes.real_shipping + _vm.orderDataShow.attributes.cut)))) + "% respecto a tu inversión.")])]) : (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('div', {
    staticClass: "msj-inversion"
  }, [_c('span', [_vm._v("Inviertes " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.real_price + _vm.orderDataShow.attributes.real_tax + _vm.orderDataShow.attributes.real_shipping + _vm.orderDataShow.attributes.cut)) + "\n    y ganas " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linio_evaluation_info.attributes.linio_total + _vm.orderDataShow.attributes.linioOrder.attributes.debit - (_vm.orderDataShow.attributes.linio_evaluation_info.attributes.real_total_cost))) + ".\n    Un  " + _vm._s(_vm._f("currency")((((_vm.orderDataShow.attributes.linio_evaluation_info.attributes.linio_total + _vm.orderDataShow.attributes.linioOrder.attributes.debit - (_vm.orderDataShow.attributes.linio_evaluation_info.attributes.real_total_cost)) * 100) / (_vm.orderDataShow.attributes.real_price + _vm.orderDataShow.attributes.real_tax + _vm.orderDataShow.attributes.real_shipping + _vm.orderDataShow.attributes.cut)))) + "% respecto a tu inversión.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-content-details-container"
  }, [_c('div', {
    staticClass: "card-content-details-block"
  }, [_c('div', {
    staticClass: "card-content-details"
  }, [_c('div', {
    staticClass: "details-title-container"
  }, [_c('div', {
    staticClass: "details-title-block details-summary-item",
    staticStyle: {
      "justify-content": "center"
    }
  }, [(_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('span', {
    staticClass: "details-title-item",
    staticStyle: {
      "font-weight": "bold",
      "text-decoration": "underline"
    }
  }, [_vm._v("Datos sugeridos por web de Grabr")]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item",
    staticStyle: {
      "font-weight": "bold",
      "text-decoration": "underline"
    }
  }, [_vm._v("Datos sugeridos por web de Linio")]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item",
    staticStyle: {
      "font-weight": "bold",
      "text-decoration": "underline"
    }
  }, [_vm._v("Datos sugeridos por web de Meli")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Precio")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.grabrOrder.attributes.grabr_price_rechecked)))]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.linio_price_rechecked)))]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.meli_price_rechecked)))]) : _vm._e()]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.reward_discount != null) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Reward / Discount")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ 0")])]) : (_vm.orderDataShow.attributes.is_from_linio_flag && _vm.orderDataShow.attributes.linioOrder.attributes.reward_discount != null) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Reward / Discount")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ 0")])]) : (_vm.orderDataShow.attributes.is_from_meli_flag && _vm.orderDataShow.attributes.meliOrder.attributes.reward_discount != null) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Reward / Discount")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ 0")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Tax")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.grabrOrder.attributes.grabr_tax_rechecked)))]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.linio_tax_rechecked)))]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.meli_tax_rechecked)))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Shipping")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.grabrOrder.attributes.grabr_shipping_web)))]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.linio_shipping_web)))]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.meli_shipping_web)))]) : _vm._e()]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Adeudo")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.grabrOrder.attributes.debit)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fob (Subtotal)")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.grabrOrder.attributes.grabr_price_rechecked + _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_tax_rechecked + _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_shipping_web)))]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.linio_price_rechecked + _vm.orderDataShow.attributes.linioOrder.attributes.linio_tax_rechecked + _vm.orderDataShow.attributes.linioOrder.attributes.linio_shipping_web)))]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.meli_price_rechecked + _vm.orderDataShow.attributes.meliOrder.attributes.meli_tax_rechecked + _vm.orderDataShow.attributes.meliOrder.attributes.meli_shipping_web)))]) : _vm._e()]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Seguro")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.linio_security_cost)))])]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Seguro")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.meli_security_cost)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Flete")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.linio_flete_cost)))])]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Flete")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.meli_flete_cost)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("CIF (Subtotal 2)")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.cif)))])]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("CIF (Subtotal 2)")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.cif)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: (
        'Ad Valorem: $ ' + _vm.orderDataShow.attributes.linioOrder.attributes.linio_ad_valorem +
        '\nIGV: $ ' + _vm.orderDataShow.attributes.linioOrder.attributes.linio_igv +
        '\nIPM: $ ' + _vm.orderDataShow.attributes.linioOrder.attributes.linio_ipm),
      expression: "\n              'Ad Valorem: $ ' + orderDataShow.attributes.linioOrder.attributes.linio_ad_valorem +\n              '\\nIGV: $ ' + orderDataShow.attributes.linioOrder.attributes.linio_igv +\n              '\\nIPM: $ ' + orderDataShow.attributes.linioOrder.attributes.linio_ipm",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "details-title-item"
  }, [_vm._v("Impuestos")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.linio_ad_valorem + _vm.orderDataShow.attributes.linioOrder.attributes.linio_igv + _vm.orderDataShow.attributes.linioOrder.attributes.linio_ipm)))])]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: (
        'Ad Valorem: $ ' + _vm.orderDataShow.attributes.meliOrder.attributes.meli_ad_valorem +
        '\nIGV: $ ' + _vm.orderDataShow.attributes.meliOrder.attributes.meli_igv +
        '\nIPM: $ ' + _vm.orderDataShow.attributes.meliOrder.attributes.meli_ipm),
      expression: "\n              'Ad Valorem: $ ' + orderDataShow.attributes.meliOrder.attributes.meli_ad_valorem +\n              '\\nIGV: $ ' + orderDataShow.attributes.meliOrder.attributes.meli_igv +\n              '\\nIPM: $ ' + orderDataShow.attributes.meliOrder.attributes.meli_ipm",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "details-title-item"
  }, [_vm._v("Impuestos")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.meli_ad_valorem + _vm.orderDataShow.attributes.meliOrder.attributes.meli_igv + _vm.orderDataShow.attributes.meliOrder.attributes.meli_ipm)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Guía: $8.00' + '\nIGV: $1.44'),
      expression: "'Guía: $8.00' + '\\nIGV: $1.44'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "details-title-item"
  }, [_vm._v("Trámite Aduanero")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm.customsProcedureConstant))])]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Costo Total")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.cif + (_vm.orderDataShow.attributes.linioOrder.attributes.linio_ad_valorem + _vm.orderDataShow.attributes.linioOrder.attributes.linio_igv + _vm.orderDataShow.attributes.linioOrder.attributes.linio_ipm) + _vm.customsProcedureConstant)))])]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Costo Total")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.cif + (_vm.orderDataShow.attributes.meliOrder.attributes.meli_ad_valorem + _vm.orderDataShow.attributes.meliOrder.attributes.meli_igv + _vm.orderDataShow.attributes.meliOrder.attributes.meli_ipm) + _vm.customsProcedureConstant)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: (Number(Math.round(parseFloat(((_vm.orderDataShow.attributes.evaluation_info.attributes.grabr_total + _vm.orderDataShow.attributes.grabrOrder.attributes.debit - (_vm.orderDataShow.attributes.evaluation_info.attributes.web_total_cost)) * 100) / (_vm.orderDataShow.attributes.grabrOrder.attributes.grabr_price + _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_tax + _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_fee + _vm.orderDataShow.attributes.grabrOrder.attributes.debit)) + 'e2') + 'e-2').toFixed(2).toString() + '%'),
      expression: "Number(Math.round(parseFloat((( orderDataShow.attributes.evaluation_info.attributes.grabr_total + orderDataShow.attributes.grabrOrder.attributes.debit - (orderDataShow.attributes.evaluation_info.attributes.web_total_cost))*100)/(orderDataShow.attributes.grabrOrder.attributes.grabr_price+orderDataShow.attributes.grabrOrder.attributes.grabr_tax+orderDataShow.attributes.grabrOrder.attributes.grabr_fee + orderDataShow.attributes.grabrOrder.attributes.debit)) + 'e2') + 'e-2').toFixed(2).toString() + '%'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "details-title-item"
  }, [_vm._v("Utilidad\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.evaluation_info.attributes.grabr_total + _vm.orderDataShow.attributes.grabrOrder.attributes.debit - (_vm.orderDataShow.attributes.evaluation_info.attributes.web_total_cost))))])]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: (Number(Math.round(parseFloat(((_vm.orderDataShow.attributes.linio_evaluation_info.attributes.linio_total +
          _vm.orderDataShow.attributes.linioOrder.attributes.debit -
          (_vm.orderDataShow.attributes.linio_evaluation_info.attributes.web_total_cost)) * 100) /
        (_vm.orderDataShow.attributes.linioOrder.attributes.linio_price +
          _vm.orderDataShow.attributes.linioOrder.attributes.debit)) + 'e2') + 'e-2').toFixed(2).toString() + '%'),
      expression: "Number(Math.round(parseFloat(((orderDataShow.attributes.linio_evaluation_info.attributes.linio_total +\n              orderDataShow.attributes.linioOrder.attributes.debit -\n              (orderDataShow.attributes.linio_evaluation_info.attributes.web_total_cost))*100)\n              /(orderDataShow.attributes.linioOrder.attributes.linio_price\n              + orderDataShow.attributes.linioOrder.attributes.debit)) + 'e2') + 'e-2').toFixed(2).toString() + '%'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "details-title-item"
  }, [_vm._v("\n              Utilidad\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.linio_price - (_vm.orderDataShow.attributes.linioOrder.attributes.cif + (_vm.orderDataShow.attributes.linioOrder.attributes.linio_ad_valorem + _vm.orderDataShow.attributes.linioOrder.attributes.linio_igv + _vm.orderDataShow.attributes.linioOrder.attributes.linio_ipm) + _vm.customsProcedureConstant))))])]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: (Number(Math.round(parseFloat(((_vm.orderDataShow.attributes.meli_evaluation_info.attributes.meli_total +
          _vm.orderDataShow.attributes.meliOrder.attributes.debit -
          (_vm.orderDataShow.attributes.meli_evaluation_info.attributes.web_total_cost)) * 100) /
        (_vm.orderDataShow.attributes.meliOrder.attributes.meli_price_dollar +
          _vm.orderDataShow.attributes.meliOrder.attributes.debit)) + 'e2') + 'e-2').toFixed(2).toString() + '%'),
      expression: "Number(Math.round(parseFloat(((orderDataShow.attributes.meli_evaluation_info.attributes.meli_total +\n              orderDataShow.attributes.meliOrder.attributes.debit -\n              (orderDataShow.attributes.meli_evaluation_info.attributes.web_total_cost))*100)\n              /(orderDataShow.attributes.meliOrder.attributes.meli_price_dollar\n              + orderDataShow.attributes.meliOrder.attributes.debit)) + 'e2') + 'e-2').toFixed(2).toString() + '%'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "details-title-item"
  }, [_vm._v("\n              Utilidad\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.meli_price_dollar - (_vm.orderDataShow.attributes.meliOrder.attributes.cif + (_vm.orderDataShow.attributes.meliOrder.attributes.meli_ad_valorem + _vm.orderDataShow.attributes.meliOrder.attributes.meli_igv + _vm.orderDataShow.attributes.meliOrder.attributes.meli_ipm) + _vm.customsProcedureConstant))))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details-title-container"
  }, [_c('div', {
    staticClass: "details-title-block details-summary-item summary-block-total"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Total")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.evaluation_info.attributes.web_total_cost)))]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.linio_price_dollar)))]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.meli_price_dollar)))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-content-details-block"
  }, [_c('div', {
    staticClass: "card-content-details"
  }, [_c('div', {
    staticClass: "details-title-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Precio")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.real_price)))])]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.reward_discount != null) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Reward / Discount")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.grabrOrder.attributes.reward_discount)))])]) : (_vm.orderDataShow.attributes.is_from_linio_flag && _vm.orderDataShow.attributes.linioOrder.attributes.reward_discount != null) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Reward / Discount")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.reward_discount)))])]) : (_vm.orderDataShow.attributes.is_from_meli_flag && _vm.orderDataShow.attributes.meliOrder.attributes.reward_discount != null) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Reward / Discount")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.reward_discount)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Tax")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.real_tax)))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Shipping")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.real_shipping)))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fob (Subtotal)")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.fob)))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Seguro")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.securityCost)))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Flete")]), _vm._v(" "), (!this.costingMethodFlag) ? _c('div', [_c('span'), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.fleteCost)))])]) : _c('div', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fleteCost),
      expression: "fleteCost"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control null",
    domProps: {
      "value": (_vm.fleteCost)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.updatePurchaseOrder.apply(null, arguments)
      }, function($event) {
        return _vm.calculated()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fleteCost = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("CIF (Subtotal 2)")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.cif)))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Ad Valorem: $ ' + _vm.adValorem +
        '\nIGV: $ ' + _vm.igv +
        '\nIPM: $ ' + _vm.ipm),
      expression: "'Ad Valorem: $ ' + adValorem +\n                                    '\\nIGV: $ ' + igv +\n                                    '\\nIPM: $ ' + ipm",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "details-title-item"
  }, [_vm._v("Impuestos")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.adValorem + _vm.igv + _vm.ipm)))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Guía: $8.00' + '\nIGV: $1.44'),
      expression: "'Guía: $8.00' + '\\nIGV: $1.44'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "details-title-item"
  }, [_vm._v("Trámite Aduanero")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.customsProcedure)))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Costo Total")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.costoTotal)))])]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: (Number(Math.round(parseFloat(((_vm.orderDataShow.attributes.evaluation_info.attributes.grabr_total + _vm.orderDataShow.attributes.grabrOrder.attributes.debit - (_vm.orderDataShow.attributes.evaluation_info.attributes.real_total_cost)) * 100) / (_vm.orderDataShow.attributes.grabrOrder.attributes.grabr_price + _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_tax + _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_fee + _vm.orderDataShow.attributes.grabrOrder.attributes.debit)) + 'e2') + 'e-2').toFixed(2).toString() + '%'),
      expression: "Number(Math.round(parseFloat(((orderDataShow.attributes.evaluation_info.attributes.grabr_total + orderDataShow.attributes.grabrOrder.attributes.debit - (orderDataShow.attributes.evaluation_info.attributes.real_total_cost))*100)/(orderDataShow.attributes.grabrOrder.attributes.grabr_price+orderDataShow.attributes.grabrOrder.attributes.grabr_tax+orderDataShow.attributes.grabrOrder.attributes.grabr_fee + orderDataShow.attributes.grabrOrder.attributes.debit)) + 'e2') + 'e-2').toFixed(2).toString() + '%'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "details-title-item"
  }, [_vm._v("Utilidad")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.evaluation_info.attributes.grabr_total + _vm.orderDataShow.attributes.grabrOrder.attributes.debit - (_vm.orderDataShow.attributes.evaluation_info.attributes.real_total_cost))))])]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: (Number(Math.round(parseFloat(((_vm.orderDataShow.attributes.linio_evaluation_info.attributes.linio_total + _vm.orderDataShow.attributes.linioOrder.attributes.debit - (_vm.orderDataShow.attributes.linio_evaluation_info.attributes.real_total_cost)) * 100) / (_vm.orderDataShow.attributes.linioOrder.attributes.linio_price + _vm.orderDataShow.attributes.linioOrder.attributes.debit)) + 'e2') + 'e-2').toFixed(2).toString() + '%'),
      expression: "Number(Math.round(parseFloat(((orderDataShow.attributes.linio_evaluation_info.attributes.linio_total + orderDataShow.attributes.linioOrder.attributes.debit - (orderDataShow.attributes.linio_evaluation_info.attributes.real_total_cost))*100)/(orderDataShow.attributes.linioOrder.attributes.linio_price + orderDataShow.attributes.linioOrder.attributes.debit)) + 'e2') + 'e-2').toFixed(2).toString() + '%'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "details-title-item"
  }, [_vm._v("Utilidad")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.linio_price_dollar - (_vm.cif + (_vm.adValorem + _vm.igv + _vm.ipm) + _vm.customsProcedure))))])]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: (Number(Math.round(parseFloat(((_vm.orderDataShow.attributes.meli_evaluation_info.attributes.meli_total + _vm.orderDataShow.attributes.meliOrder.attributes.debit - (_vm.orderDataShow.attributes.meli_evaluation_info.attributes.real_total_cost)) * 100) / (_vm.orderDataShow.attributes.meliOrder.attributes.meli_price_dollar + _vm.orderDataShow.attributes.meliOrder.attributes.debit)) + 'e2') + 'e-2').toFixed(2).toString() + '%'),
      expression: "Number(Math.round(parseFloat(((orderDataShow.attributes.meli_evaluation_info.attributes.meli_total + orderDataShow.attributes.meliOrder.attributes.debit - (orderDataShow.attributes.meli_evaluation_info.attributes.real_total_cost))*100)/(orderDataShow.attributes.meliOrder.attributes.meli_price_dollar + orderDataShow.attributes.meliOrder.attributes.debit)) + 'e2') + 'e-2').toFixed(2).toString() + '%'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "details-title-item"
  }, [_vm._v("Utilidad")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.meli_price_dollar - (_vm.cif + (_vm.adValorem + _vm.igv + _vm.ipm) + _vm.customsProcedure))))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details-title-container"
  }, [_c('div', {
    staticClass: "details-title-block details-summary-item summary-block-total"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Total")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.linio_price_dollar)))]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.meli_price_dollar)))]) : _vm._e()])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-title-block details-summary-item",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('span', {
    staticClass: "details-title-item",
    staticStyle: {
      "font-weight": "bold",
      "text-decoration": "underline"
    }
  }, [_vm._v("Datos reales")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6dc17366"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/prefab/elements/resume-purchase-order.vue
// module id = 1892
// module chunks = 1